/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 14:55:08
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Card, TextStyle, FormLayout, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';

type Props = {};

type ComposedProps = Props & WithI18nProps;

class Settings extends Component<ComposedProps> {
  render() {
    const { i18n, emailSupport } = this.props;

    return (
      <div className="BC_FilterLayout-Settings">
        <Card sectioned>
          <p>
            {i18n.translate('AdminHTML.FilterLayout.Settings.description', {
              nt_break: <br />,
              nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
            })}
          </p>
          <FormLayout>
            <Stack distribution="fill">
              <Field
                name="stickyFilterOnDesktop"
                component={RenderToggleSwitch}
                label={i18n.translate(
                  'AdminHTML.FilterLayout.Settings.stickyFilterOnDesktop_Label'
                )}
              />
              <Field
                name="stickyFilterOnMobile"
                component={RenderToggleSwitch}
                label={i18n.translate('AdminHTML.FilterLayout.Settings.stickyFilterOnMobile_Label')}
              />
            </Stack>
          </FormLayout>
        </Card>
      </div>
    );
  }
}

export default withI18n()(Settings);
